export const getUsers = {
  users: [
    {
      id: '47fe65c1-0ba5-43c2-b84a-ac20ccb4bae2',
      name: 'Jeffy Reace',
      email: 'jreace0@histats.com',
      isDeleted: true,
    },
    {
      id: 'a5bc2e83-3f59-41a8-b452-648c381f33ea',
      name: 'Demetris Pallas',
      email: 'dpallas1@businessweek.com',
      isDeleted: false,
    },
    {
      id: '7aa52bb5-2acd-4b30-ae49-d49c57dd617e',
      name: 'Danyette Widdecombe',
      email: 'dwiddecombe2@cbsnews.com',
      isDeleted: true,
    },
    {
      id: '1c5c4fbf-e95b-48cf-bb0f-9051a5d01f96',
      name: 'Tobin Joicey',
      email: 'tjoicey3@japanpost.jp',
      isDeleted: false,
    },
    {
      id: 'add970fb-ed0d-4c17-a05f-29ec02c1fd85',
      name: 'Karlene Seal',
      email: 'kseal4@apple.com',
      isDeleted: true,
    },
    {
      id: 'e081a43a-ab97-449e-a0b4-f5faeba51170',
      name: 'Layney Considine',
      email: 'lconsidine5@answers.com',
      isDeleted: true,
    },
    {
      id: '18f56dc7-7c00-4d30-8f70-f2c19c4bb28b',
      name: 'Glyn Verrell',
      email: 'gverrell6@purevolume.com',
      isDeleted: false,
    },
    {
      id: '94c4f256-d884-4568-83d8-86cbf1d6a944',
      name: 'Celie Reeken',
      email: 'creeken7@1688.com',
      isDeleted: false,
    },
    {
      id: '1858fbee-52a6-40b7-9e4a-43432131e1be',
      name: 'Nicolea Maudling',
      email: 'nmaudling8@t.co',
      isDeleted: false,
    },
    {
      id: 'b6761bec-0cc1-4523-8f36-ca8a43a63eaf',
      name: 'Randee Brauninger',
      email: 'rbrauninger9@sitemeter.com',
      isDeleted: true,
    },
    {
      id: '6c14819a-104b-4bf0-bd4a-29e45303c9cd',
      name: 'Ynez Aberkirdo',
      email: 'yaberkirdoa@china.com.cn',
      isDeleted: true,
    },
    {
      id: 'd4a02b9b-c7ab-4669-b9fd-1ec909c2724c',
      name: 'Den Roby',
      email: 'drobyb@deliciousdays.com',
      isDeleted: false,
    },
    {
      id: '60aa8d21-8218-4b45-904a-724d81b45d5c',
      name: 'Horatio Aleksashin',
      email: 'haleksashinc@eventbrite.com',
      isDeleted: false,
    },
    {
      id: '3ee0d6c4-9680-4e56-a7f1-5375377cb302',
      name: 'Rasia Kochlin',
      email: 'rkochlind@biblegateway.com',
      isDeleted: true,
    },
    {
      id: '220d71ae-16ea-45e2-8973-5d39a3701091',
      name: 'Chad Leyrroyd',
      email: 'cleyrroyde@tinypic.com',
      isDeleted: true,
    },
    {
      id: '7a6aef9f-e54a-4e84-b1cd-f25f94a6358f',
      name: 'Rafaello Bernt',
      email: 'rberntf@ucsd.edu',
      isDeleted: true,
    },
    {
      id: '63aac3d9-f0ad-4e40-b735-2a9586d7f51e',
      name: 'Sheila Streetley',
      email: 'sstreetleyg@ifeng.com',
      isDeleted: false,
    },
    {
      id: '00df30d8-a31f-408b-82e1-9078a386f56a',
      name: 'Kale Heaker',
      email: 'kheakerh@storify.com',
      isDeleted: false,
    },
    {
      id: '8a4d1a4f-6577-4e9e-840f-a736722e1a2c',
      name: 'Etheline Guilfoyle',
      email: 'eguilfoylei@archive.org',
      isDeleted: false,
    },
    {
      id: '5c7eee10-8bdc-458e-8764-d857168623f8',
      name: 'Rhona Stallebrass',
      email: 'rstallebrassj@bloglines.com',
      isDeleted: true,
    },
  ],
}

export const getCurrentUser = {
  userId: '5b1bf2f1-2c9b-489c-9197-e5d3d261aaf3',
  userName: 'User Name',
  email: 'user@mail.com',
  capabilities: ['ACCESS_MANAGEMENT', 'CLIENT_CONFIG_MANAGEMENT', 'INCIDENT_MANAGEMENT'],
}

export const getCategory1List = [
  {
    name: '_config-client-id',
  },
  {
    name: 'marketing.analytics.google',
  },
  {
    name: 'accounting.software.quickbooks',
  },
  {
    name: 'sales.automation.hubspot',
  },
  {
    name: 'inventory.management.warehouse',
  },
  {
    name: 'marketing.analytics.google1',
  },
  {
    name: 'marketing.analytics.google2',
  },
  {
    name: 'data.storage.aws.s3',
  },
  {
    name: 'employee.training.skillsoft',
  },
  {
    name: 'employee.training.skillsoft1',
  },
  {
    name: 'communication.platform.slack',
  },
  {
    name: 'communication.platform.slack1',
  },
  {
    name: 'communication.platform.slack2',
  },
  {
    name: 'inventory.management.warehouse1',
  },
  {
    name: 'project.management.trello',
  },
  {
    name: 'marketing.analytics.google3',
  },
  {
    name: 'security.monitoring.fireeye',
  },
  {
    name: 'accounting.software.quickbooks5',
  },
  {
    name: 'marketing.analytics.google4',
  },
  {
    name: 'payment.gateway.paypal',
  },
  {
    name: 'project.management.trello1',
  },
]

export const getCategory2List = [
  {
    name: 'payment.gateway.paypal1',
  },
  {
    name: 'communication.platform.slack3',
  },
  {
    name: 'sales.automation.hubspot1',
  },
  {
    name: 'employee.training.skillsoft',
  },
  {
    name: 'accounting.software.quickbooks1',
  },
  {
    name: 'payment.gateway.paypal2',
  },
  {
    name: 'sales.automation.hubspot2',
  },
  {
    name: 'customer.service.support',
  },
]

export const getConfiguration = {
  current: {
    configurationId: 'config-client-id',
    configCategory: 'category1',
    somePropertyString: 'someValue1',
    somePropertyBoolean: true,
    somePropertyAnotherBoolean: false,
    somePropertyNumber: 1,
    somePropertyAnotherNumber: 0,
    somePropertyNull: null,
    somePropertyArray: ['qwerty', 1, true, null, undefined],
    somePropertyObject: {
      somePropertyString: 'someValue1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 1,
      somePropertyAnotherNumber: 0,
      somePropertyNull: null,
      somePropertyArray: ['qwerty', 1, true, null, undefined],
    },
  },
  versions: [
    {
      version: 1,
      configurationId: 'config-client-id:1',
      somePropertyString: 'someValueOld',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 1234,
      somePropertyAnotherNumber: 0,
      somePropertyNull: null,
      somePropertyArray: ['qwerty'],
      somePropertyObject: {
        somePropertyString: 'someValue1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNull: null,
        somePropertyArray: [],
      },
    },
  ],
  references: ['service-name-1'],
  referenceMapping: [
    {
      unresolvedPath: 'current/somePropertyString',
      resolvedValue: {
        version: 1,
        value: 'someValueOld',
        someDetails: 'someDetails1',
      },
    },
    {
      unresolvedPath: 'current/somePropertyArray/0',
      resolvedValue: {
        version: 1,
        value: 'qwerty',
        someDetails: 'someDetails2',
      },
    },
    {
      unresolvedPath: 'current/somePropertyObject/somePropertyString',
      resolvedValue: {
        version: 1,
        value: 'someValue1',
        someDetails: 'someDetails3',
      },
    },
  ],
}

export const configurations = [
  {
    current: {
      configurationId: '_config-client-id',
      configCategory: 'category1',
      somePropertyString: 'someValue1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 1,
      somePropertyAnotherNumber: 0,
      somePropertyNull: null,
      somePropertyArray: ['qwerty', 1, true, null],
      somePropertyObject: {
        somePropertyString: 'someValue1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 1,
        somePropertyAnotherNumber: 0,
        somePropertyNull: null,
        somePropertyArray: ['qwerty', 1, true],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: '_config-client-id:1',
        somePropertyString: 'someValueOld',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 1234,
        somePropertyAnotherNumber: 0,
        somePropertyNull: null,
        somePropertyArray: ['qwerty'],
        somePropertyObject: {
          somePropertyString: 'someValue1',
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyNull: null,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [
      {
        unresolvedPath: 'current',
        resolvedValue: {
          info: 'this is preview',
        },
      },
      {
        unresolvedPath: 'current/somePropertyArray[0]',
        resolvedValue: {
          value: 'qwerty',
          someDetails: 'someDetails2',
        },
      },
      {
        unresolvedPath: 'current/somePropertyObject/somePropertyArray',
        resolvedValue: {
          value: 'someValue2',
          someDetails: 'someDetails3',
        },
      },
      {
        unresolvedPath: 'current/somePropertyObject/somePropertyArray[2]',
        resolvedValue: {
          value: 'someValue3',
          someDetails: 'someDetails3',
        },
      },
    ],
  },
  {
    current: {
      configurationId: 'marketing.analytics.google',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 1088,
      somePropertyArray: [{}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 430,
        somePropertyArray: [{}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'marketing.analytics.google:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 1034,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'accounting.software.quickbooks',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 766,
      somePropertyArray: [{}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 161,
        somePropertyArray: [{}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'accounting.software.quickbooks:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 208,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'sales.automation.hubspot',
      configCategory: 'category1',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 570,
      somePropertyArray: [{}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 218,
        somePropertyArray: [{}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'sales.automation.hubspot:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 296,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'inventory.management.warehouse',
      configCategory: 'category1',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 675,
      somePropertyArray: [{}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 245,
        somePropertyArray: [],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'inventory.management.warehouse:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 333,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'marketing.analytics.google1',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 359,
      somePropertyArray: [{}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 766,
        somePropertyArray: [{}, {}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'marketing.analytics.google1:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 818,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'marketing.analytics.google2',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 644,
      somePropertyArray: [{}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 775,
        somePropertyArray: [{}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'marketing.analytics.google2:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 344,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'data.storage.aws.s3',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 98,
      somePropertyArray: [{}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 473,
        somePropertyArray: [],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'data.storage.aws.s3:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 41,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'employee.training.skillsoft',
      configCategory: 'category1',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 1194,
      somePropertyArray: [{}, {}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 318,
        somePropertyArray: [],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'employee.training.skillsoft:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 439,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'employee.training.skillsoft1',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 972,
      somePropertyArray: [{}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 561,
        somePropertyArray: [],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'employee.training.skillsoft1:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 197,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'communication.platform.slack',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 853,
      somePropertyArray: [{}, {}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 386,
        somePropertyArray: [],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'communication.platform.slack:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 1168,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'communication.platform.slack1',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 1162,
      somePropertyArray: [{}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 443,
        somePropertyArray: [{}, {}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'communication.platform.slack1:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 1093,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'communication.platform.slack2',
      configCategory: 'category1',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 802,
      somePropertyArray: [],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 462,
        somePropertyArray: [],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'communication.platform.slack2:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 470,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'inventory.management.warehouse1',
      configCategory: 'category1',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 481,
      somePropertyArray: [{}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 263,
        somePropertyArray: [{}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'inventory.management.warehouse1:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 827,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'project.management.trello',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 124,
      somePropertyArray: [{}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 987,
        somePropertyArray: [{}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'project.management.trello:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 782,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'marketing.analytics.google3',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 157,
      somePropertyArray: [{}, {}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 265,
        somePropertyArray: [{}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'marketing.analytics.google3:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 1054,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'security.monitoring.fireeye',
      configCategory: 'category1',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 390,
      somePropertyArray: [{}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 758,
        somePropertyArray: [{}, {}, {}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'security.monitoring.fireeye:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 73,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'accounting.software.quickbooks5',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 780,
      somePropertyArray: [],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 987,
        somePropertyArray: [{}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'accounting.software.quickbooks5:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 977,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'marketing.analytics.google4',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 431,
      somePropertyArray: [{}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 146,
        somePropertyArray: [{}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'marketing.analytics.google4:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 1081,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'payment.gateway.paypal',
      configCategory: 'category1',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 142,
      somePropertyArray: [{}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 6,
        somePropertyArray: [{}, {}, {}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'payment.gateway.paypal:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 378,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'project.management.trello1',
      configCategory: 'category1',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 670,
      somePropertyArray: [{}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 151,
        somePropertyArray: [{}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'project.management.trello1:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 189,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'payment.gateway.paypal1',
      configCategory: 'category2',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 823,
      somePropertyArray: [],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 394,
        somePropertyArray: [{}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'payment.gateway.paypal1:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 280,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'communication.platform.slack3',
      configCategory: 'category2',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 1188,
      somePropertyArray: [{}, {}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 789,
        somePropertyArray: [{}, {}, {}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'communication.platform.slack3:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 1065,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'sales.automation.hubspot1',
      configCategory: 'category2',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 149,
      somePropertyArray: [{}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 950,
        somePropertyArray: [{}, {}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'sales.automation.hubspot1:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 817,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'employee.training.skillsoft',
      configCategory: 'category2',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 420,
      somePropertyArray: [{}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 218,
        somePropertyArray: [],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'employee.training.skillsoft:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 28,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'accounting.software.quickbooks1',
      configCategory: 'category2',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 156,
      somePropertyArray: [{}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 1158,
        somePropertyArray: [{}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'accounting.software.quickbooks1:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 236,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'payment.gateway.paypal2',
      configCategory: 'category2',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: false,
      somePropertyNumber: 786,
      somePropertyArray: [{}, {}, {}, {}, {}],
      somePropertyObject: {
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 730,
        somePropertyArray: [{}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'payment.gateway.paypal2:1',
        somePropertyBoolean: false,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 71,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'sales.automation.hubspot2',
      configCategory: 'category2',
      somePropertyBoolean: true,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 279,
      somePropertyArray: [{}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 157,
        somePropertyArray: [{}, {}, {}, {}, {}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'sales.automation.hubspot2:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 909,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: true,
          somePropertyAnotherBoolean: true,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
  {
    current: {
      configurationId: 'customer.service.support',
      configCategory: 'category2',
      somePropertyBoolean: false,
      somePropertyAnotherBoolean: true,
      somePropertyNumber: 372,
      somePropertyArray: [{}],
      somePropertyObject: {
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: true,
        somePropertyNumber: 247,
        somePropertyArray: [{}],
      },
    },
    versions: [
      {
        version: 1,
        configurationId: 'customer.service.support:1',
        somePropertyBoolean: true,
        somePropertyAnotherBoolean: false,
        somePropertyNumber: 1050,
        somePropertyArray: [{}],
        somePropertyObject: {
          somePropertyBoolean: false,
          somePropertyAnotherBoolean: false,
          somePropertyArray: [],
        },
      },
    ],
    references: ['service-name-1'],
    referenceMapping: [{}],
  },
]

export const getGroupList = {
  groups: [
    {
      id: '75a8ad4b-272a-4e4d-ad89-5ee3003b154a',
      name: 'Goldeneye',
    },
    {
      id: '8c4d4c10-fa9b-4aaf-80c8-7300e855716c',
      name: 'Goat',
    },
    {
      id: 'bbb503ec-4834-4de0-b546-e5ef05cbb355',
      name: 'Tortoise',
    },
    {
      id: '0a141fd3-6e22-47dd-99e5-5442b9cc2274',
      name: 'Bison',
    },
    {
      id: 'c9b3db18-73de-40c6-b630-43b1cddf38f8',
      name: 'Mockingbird',
    },
    {
      id: '8cdeb17a-a443-4662-8358-e67874856ed6',
      name: 'Eagle',
    },
    {
      id: '906d09bf-396c-48d6-844a-e9d04e72e4ee',
      name: 'Goose',
    },
    {
      id: 'affffc19-334e-41e3-96eb-c6f5a7dc9759',
      name: 'Trumpeter',
    },
  ],
}

export const getGroupDetails = {
  id: 'affffc19-334e-41e3-96eb-c6f5a7dc9759',
  name: 'Trumpeter',
  members: [
    {
      userId: '47fe65c1-0ba5-43c2-b84a-ac20ccb4bae2',
      name: 'Jeffy Reace',
      email: 'jreace0@histats.com',
      isDeleted: true,
    },
    {
      userId: 'a5bc2e83-3f59-41a8-b452-648c381f33ea',
      name: 'Demetris Pallas',
      email: 'dpallas1@businessweek.com',
      isDeleted: false,
    },
    {
      userId: '7aa52bb5-2acd-4b30-ae49-d49c57dd617e',
      name: 'Danyette Widdecombe',
      email: 'dwiddecombe2@cbsnews.com',
      isDeleted: true,
    },
  ],
}

export const getPermissions = {
  permissions: [
    {
      resourceType: 'Config',
      resourceName: 'name 4',
      operation: 'Write',
      allowedGroups: [
        {
          id: 'affffc19-334e-41e3-96eb-c6f5a7dc9759',
          name: 'Trumpeter',
        },
      ],
    },
    {
      resourceType: 'Config',
      resourceName: 'name 4',
      operation: 'Read',
      allowedGroups: [
        {
          id: '8cdeb17a-a443-4662-8358-e67874856ed6',
          name: 'Eagle',
        },
      ],
    },
    {
      resourceType: 'Config',
      resourceName: 'name 4',
      operation: 'Delete',
      allowedGroups: [
        {
          id: '8cdeb17a-a443-4662-8358-e67874856ed6',
          name: 'Eagle',
        },
        {
          id: 'c9b3db18-73de-40c6-b630-43b1cddf38f8',
          name: 'Mockingbird',
        },
      ],
    },
    {
      resourceType: 'Config',
      resourceName: 'name 3',
      operation: 'Write',
      allowedGroups: [
        {
          id: 'c9b3db18-73de-40c6-b630-43b1cddf38f8',
          name: 'Mockingbird',
        },
      ],
    },
    {
      resourceType: 'Config',
      resourceName: 'name 2',
      operation: 'Write',
      allowedGroups: [],
    },
    {
      resourceType: 'Config',
      resourceName: 'name 3',
      operation: 'Delete',
      allowedGroups: [],
    },
  ],
}

export const capabilityRes = {
  resourceType: 'test',
  resourceName: 'test-id',
  operation: 'all',
  authorized: true,
}
